import { Colors } from 'cio-design-library/design-tokens'
import { Container, IconContainer, Text, TextContainer, Title } from './styles'

export enum BadgeEnum {
  green = 'green',
  orange = 'orange',
  indigo = 'indigo',
}
export interface Props {
  icon?: React.ReactNode
  title?: string
  text: string
  type: BadgeEnum
}

interface Value {
  textColor: string
}

const colors: Record<BadgeEnum, Value> = {
  [BadgeEnum.green]: {
    textColor: Colors.Green50,
  },
  [BadgeEnum.orange]: {
    textColor: Colors.Orange50,
  },
  [BadgeEnum.indigo]: {
    textColor: Colors.Indigo50,
  },
}

export const Badge = ({ icon, text, type, title }: Props) => {
  const color = colors[type]
  if (!color) {
    return null
  }
  return (
    <Container>
      <IconContainer $color={color.textColor}>{icon}</IconContainer>
      <TextContainer>
        <Title>{title}</Title>
        <Text $color={color.textColor}>{text}</Text>
      </TextContainer>
    </Container>
  )
}
